import {defineStore} from 'pinia';
import axios from "../plugins/axios";
import RatingStatistic from "@/model/RatingStatistic";
import RatingStatisticDetail from "@/model/RatingStatisticDetail";
import { Interface } from 'readline';
import BusinessTimeBlockCollection from '@/model/business/BusinessTimeBlockCollection'
import MenuGroupList from '@/model/menu/MenuGroupList'
import * as actionTypes from '@/store/action-types'
import { FetchStructuredMenuOfferWithCancelTokenPayload } from '@/types/payload'
import { StructuredMenuOfferResponse } from '@/types/service-response'
import { AxiosResponse } from 'axios'
import moment from 'moment/moment'
import BusinessModel from '@/model/menu/BusinessModel'

export const usePiniaStore = defineStore('pinia', {

  actions: {
    /**
     * Konfiguračné skupiny
     *
     * Pôvodná implementácia načítavala skupiny len pre konkrétne výdajné miesto.
     */
    async fetchConfigurationGroups (businessId?: number): Promise<any[]> {
      let params: any = {}

      if (businessId) {
        params['business.id'] = businessId;
      }

      const response = await axios.get('/api/configuration-group', {
        params
      })
      return response.data
    },

    async fetchTimeBlocks (payload: any): Promise<any[]> {
      const response = await axios.get(`/api/time-block`, {
        params: {
          'business.id': payload
        }
      })

      return BusinessTimeBlockCollection.createFromResponseList(response.data)
    },

    async fetchMenuGroups(payload: Number): Promise<MenuGroupList[]> {
      const response = await axios.get(`/api/menu-group?businessId=${payload}`)

      return MenuGroupList.createFromResponseList(response.data)
    },

    async fetchCustomerData(): Promise<any> {

      const response = await axios.get('/api/customer')

      return response
    },

    async fetchSummaryMenuGroupSlot(payload: string): Promise<any> {

      const response = await axios.get('api/statistics/reservation-summary',
          {
            params: {
              date: payload
            }
          })

      return response

    },

    async fetchDisCountList(): Promise<any> {

      const response = await axios.get('/api/discount')

      return response

    },

    async updateSelectedDiscountGroup(payload: any[],id: string): Promise<any> {
      let targetValue: string = ''
       payload.forEach((item: any)=>{
        targetValue = item
      })

      const response = await axios.put(`/api/discount/${id}`,{
          'targetBoarders': payload
      })
      return response

    },

    async fetchRating(payload: any): Promise<any> {
      const response = await axios.post(`/api/statistics/offer-reservation-rating-summary`,{
        customer: payload.customer,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      })
      return RatingStatistic.createFromResponse(response.data)
    },

    async fetchRatingDetail(payload: any): Promise<any> {
      const response = await axios.post(`/api/statistics/offer-reservation-rating-info`,{
        customer: payload.customer,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      })
      return RatingStatisticDetail.createFromResponse(response.data)
    },

    async fetchRatingPdfReport(payload: any): Promise<any> {
      const response = await axios.post(`/api/statistics/offer-reservation-rating-report`,{
        customer: payload.customer,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      },{
        responseType: 'blob',
      })
      return response.data
    },

    async saveCustomerConfig(customerId:number, config:any): Promise<any>{
      const response = await axios.put(`/api/customer/${customerId}`,config);
      return response;
    },

    /**
     * Načítanie ponuky stravy pre dátumový rozsah
     *
     * Ponuka obsahuje štruktúrované dáta na jednotlivé dni. Skupiny, podskupiny, sloty, ponuky v slotoch a referenčné
     * jedlá.
     *
     * @param payload FetchStructuredMenuOfferPayload
     */
    async fetchStructuredMenuOffer(payload: FetchStructuredMenuOfferWithCancelTokenPayload): Promise<StructuredMenuOfferResponse> {
        const response: AxiosResponse = await axios.get(`/api/food-ordering/${payload.payload.tenantCode}/menu-offer`, {
        cancelToken: payload.cancelToken?.token,
        params: {
          's': moment(payload.payload.dateFrom).format('YYYY-MM-DD'),
          'e': moment(payload.payload.dateTo).format('YYYY-MM-DD'),
          bid: payload.payload.business?.id
        },

        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      })

      return response.data as StructuredMenuOfferResponse
    },

    async fetchBusinesses (): Promise<BusinessModel[]> {
      const response = await axios.get('/api/business')

      return response.data
    },
  }
});
